<mat-card>
  <app-card-header
    title="Setear Odómetro"
    [subtitle]="data?.identificacion"
    icono="speed"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (!data?.tracker?.uniqueId) {
      <app-info-banner
        color="red"
        icon="error"
        [closable]="false"
        message="Este vehículo no tiene un tracker asignado o el tracker no tiene uniqueId configurado."
      ></app-info-banner>
    }
    @if (formulario && data?.tracker?.uniqueId) {
      <form
        id="form-odometro"
        [formGroup]="formulario"
        (ngSubmit)="enviar()"
        autocomplete="off"
      >
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Odómetro inicial</mat-label>
            <input
              matInput
              formControlName="totalDistance"
              required
              type="number"
            />
            <mat-hint>Distancia en kilómetros</mat-hint>
          </mat-form-field>
        </section>
      </form>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="close()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="submit"
      [disabled]="!formulario?.valid || loading"
      form="form-odometro"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </mat-card-actions>
</mat-card>
